var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { staticClass: "hidden", attrs: { width: "0", height: "0" } },
    [
      _c(
        "symbol",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 14.382 15.379",
            id: "plyr-play"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M12.622 4.669a3.473 3.473 0 0 1 0 6.041l-7.435 4.216A3.473 3.473 0 0 1 0 11.906V3.473A3.473 3.473 0 0 1 5.187.453z",
              fill: "#293ad3"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "symbol",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 10 11",
            id: "plyr-pause"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M5.996 9.002v-7a2 2 0 0 1 4 0v7a2 2 0 0 1-4 0zm-6 0v-7a2 2 0 0 1 4 0v7a2 2 0 0 1-4 0z",
              fill: "#293ad3"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "symbol",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24.94 19.17",
            id: "plyr-muted"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M13.709 2.034a1 1 0 0 0-.953-.072L7.539 4.311H5.771a5.3 5.3 0 0 0 0 10.591h1.768l5.217 2.349a1 1 0 0 0 1.41-.912V2.878a.994.994 0 0 0-.457-.844zm-1.542 12.758l-4-1.8a1.022 1.022 0 0 0-.411-.088H5.774a3.3 3.3 0 1 1 0-6.591h1.982a1.022 1.022 0 0 0 .411-.088l4-1.8zm9.855-5.587l2.036-2.035a1 1 0 0 0-1.415-1.415l-2.035 2.036-2.036-2.036a1 1 0 0 0-1.415 1.415l2.036 2.035-2.036 2.036a1 1 0 0 0 1.415 1.415l2.036-2.036 2.035 2.036a1 1 0 0 0 1.415-1.415z"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "symbol",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 18.799 18.8",
            id: "plyr-exit-fullscreen"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M12.214 17.3a5.084 5.084 0 0 1 5.086-5.086 1 1 0 1 1 0 2 3.091 3.091 0 0 0-3.087 3.086 1 1 0 1 1-2 0zm-7.628 0A3.09 3.09 0 0 0 1.5 14.214a1 1 0 1 1 0-2A5.086 5.086 0 0 1 6.587 17.3a1 1 0 0 1-2 0zm7.628-15.8a1 1 0 1 1 2 0A3.093 3.093 0 0 0 17.3 4.586a1 1 0 0 1 0 2A5.087 5.087 0 0 1 12.214 1.5zM.5 5.586a1 1 0 0 1 1-1A3.09 3.09 0 0 0 4.586 1.5a1 1 0 0 1 2 0A5.087 5.087 0 0 1 1.5 6.586a1 1 0 0 1-1-1z",
              fill: "#fff",
              stroke: "rgba(0,0,0,0)"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "symbol",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 23.3 16.76",
            id: "plyr-pip"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M19.55 0H3.75A3.75 3.75 0 0 0 0 3.75V13a3.75 3.75 0 0 0 3.75 3.75h15.8A3.75 3.75 0 0 0 23.3 13V3.75A3.75 3.75 0 0 0 19.55 0zm2.25 13a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 13V3.75A2.25 2.25 0 0 1 3.75 1.5h15.8a2.25 2.25 0 0 1 2.25 2.25z"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "10.09",
              y: "5.68",
              width: "9.27",
              height: "7.12",
              rx: "2"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "symbol",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 25 25",
            id: "plyr-settings"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M23.32 11.165l-.023-.129a1.658 1.658 0 0 0-1.6-1.253h-.042a1.206 1.206 0 0 1-1.205-1.187v-.019a1.2 1.2 0 0 1 .391-.885h.005a1.562 1.562 0 0 0 .171-2.119 10.844 10.844 0 0 0-1.746-1.762 1.553 1.553 0 0 0-2.113.155 1.285 1.285 0 0 1-1.389.319 1.212 1.212 0 0 1-.727-1.108v-.163a1.56 1.56 0 0 0-1.383-1.549 10.687 10.687 0 0 0-1.235-.079 11.073 11.073 0 0 0-1.237.069 1.569 1.569 0 0 0-1.386 1.57v.079a1.219 1.219 0 0 1-.733 1.113 1.294 1.294 0 0 1-1.378-.321 1.568 1.568 0 0 0-1.135-.491 1.545 1.545 0 0 0-.96.334l-.008.008a10.966 10.966 0 0 0-1.77 1.751 1.558 1.558 0 0 0 .167 2.134 1.2 1.2 0 0 1 .4.893 1.254 1.254 0 0 1-.091.455 1.306 1.306 0 0 1-1.177.746h-.108a1.544 1.544 0 0 0-1.535 1.384v.02a10.983 10.983 0 0 0-.07 1.23 10.86 10.86 0 0 0 .071 1.25l.027.146a1.675 1.675 0 0 0 1.627 1.237h.026a1.187 1.187 0 0 1 1.1.742 1.219 1.219 0 0 1-.309 1.353 1.559 1.559 0 0 0-.171 2.121 10.948 10.948 0 0 0 1.733 1.759 1.562 1.562 0 0 0 2.12-.151 1.278 1.278 0 0 1 1.389-.32 1.2 1.2 0 0 1 .73 1.1v.166a1.562 1.562 0 0 0 1.378 1.549 10.938 10.938 0 0 0 1.268.073 11.164 11.164 0 0 0 1.205-.066 1.571 1.571 0 0 0 1.393-1.572v-.081a1.212 1.212 0 0 1 .735-1.112 1.288 1.288 0 0 1 1.383.322 1.562 1.562 0 0 0 2.088.168l.009-.008a10.86 10.86 0 0 0 1.781-1.761 1.558 1.558 0 0 0-.175-2.137h.005a1.212 1.212 0 0 1-.4-.9 1.179 1.179 0 0 1 .09-.456 1.229 1.229 0 0 1 1.122-.748h.152a1.563 1.563 0 0 0 1.551-1.375 10.677 10.677 0 0 0 .071-1.253 11.337 11.337 0 0 0-.082-1.241zm-3.827-4.967zm-.85 8.8a3.173 3.173 0 0 0 .512 3.291 8.818 8.818 0 0 1-.931.919 3.267 3.267 0 0 0-3.236-.537l-.029.011a3.218 3.218 0 0 0-1.968 2.656c-.2.014-.407.033-.61.033s-.434-.022-.652-.038a3.206 3.206 0 0 0-1.959-2.71l-.024-.01a3.26 3.26 0 0 0-3.258.53 8.8 8.8 0 0 1-.9-.915 3.187 3.187 0 0 0 .52-3.254A3.193 3.193 0 0 0 3.441 13c-.015-.214-.036-.428-.036-.644s.021-.43.036-.645A3.311 3.311 0 0 0 6.13 9.797l.014-.034a3.247 3.247 0 0 0 .248-1.239 3.208 3.208 0 0 0-.755-2.046 8.926 8.926 0 0 1 .931-.919 3.269 3.269 0 0 0 3.224.539l.038-.014a3.227 3.227 0 0 0 1.964-2.653c.212-.016.424-.037.636-.037s.417.021.626.036a3.219 3.219 0 0 0 1.948 2.706l.033.013a3.27 3.27 0 0 0 3.257-.531 8.787 8.787 0 0 1 .9.913 3.185 3.185 0 0 0-.754 2.042v.077a3.2 3.2 0 0 0 2.9 3.1c.016.216.037.433.037.648s-.022.429-.037.643A3.235 3.235 0 0 0 18.642 15z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M12.408 8.926a3.491 3.491 0 1 0 0 6.982 3.489 3.489 0 1 0 0-6.978z"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "symbol",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24.943 19.173",
            id: "plyr-volume"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M19.406 18.379a1 1 0 0 1 0-1.415 10.37 10.37 0 0 0 0-14.667A1 1 0 0 1 20.82.884a12.371 12.371 0 0 1 0 17.5 1 1 0 0 1-1.414 0zm-6.626-1.1l-5.217-2.352H5.8a5.3 5.3 0 0 1 0-10.591h1.763l5.218-2.345a1 1 0 0 1 1.41.913v13.46a1 1 0 0 1-1.41.912zM2.5 9.632a3.3 3.3 0 0 0 3.3 3.3h1.977a1.011 1.011 0 0 1 .411.088l4 1.8V4.446l-4 1.8a1.026 1.026 0 0 1-.411.087H5.8a3.3 3.3 0 0 0-3.3 3.299zm13.63 5.472a1 1 0 0 1 0-1.416 5.736 5.736 0 0 0 0-8.114 1 1 0 0 1 1.414-1.415 7.738 7.738 0 0 1 0 10.945 1 1 0 0 1-1.414 0z",
              fill: "#fff",
              stroke: "rgba(0,0,0,0)"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "symbol",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 18.801 18.802",
            id: "plyr-enter-fullscreen"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M12.217 17.299a1 1 0 0 1 1-1 3.091 3.091 0 0 0 3.088-3.083 1 1 0 1 1 1.994 0 5.089 5.089 0 0 1-5.082 5.087 1 1 0 0 1-1-1.004zM.502 13.216a1 1 0 1 1 2 0 3.091 3.091 0 0 0 3.088 3.083 1 1 0 0 1 0 2 5.092 5.092 0 0 1-5.088-5.085zm15.8-7.628A3.1 3.1 0 0 0 13.214 2.5a1 1 0 1 1 0-2A5.092 5.092 0 0 1 18.3 5.587a1 1 0 1 1-2 0zm-15.8 0A5.089 5.089 0 0 1 5.588.501a1 1 0 1 1 0 2A3.1 3.1 0 0 0 2.5 5.589a1 1 0 1 1-2 0z",
              fill: "#fff",
              stroke: "rgba(0,0,0,0)"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }